import { action, computed, makeObservable, observable } from 'mobx';
import { Maybe, just, nothing } from 'maybeasy';
import { InvitationsOptionsResource, State, ready, waiting } from './Types';
import { assertNever } from '@kofno/piper';
import InvitationsStore from '..';
import { TPlainTextKey } from '../../../../../../Translations';
import { error } from '../../../../../../ErrorHandling';
import { FlashAlert, errorAlert } from '../../../../../../Notifications/Types';

class InvitationsOptionsStore {
  @observable _state: State = waiting();

  readonly invitationsStore: InvitationsStore;

  constructor(invitationsStore: InvitationsStore) {
    makeObservable(this);
    this.invitationsStore = invitationsStore;
  }

  @action
  ready = (resource: InvitationsOptionsResource) => {
    this._state = ready(resource);
  };

  @action
  error = (msg: TPlainTextKey) => {
    this._state = error(msg);
  };

  @computed
  get state(): State {
    switch (this._state.kind) {
      case 'waiting':
        return this.invitationsStore.optionsState;
      case 'ready':
      case 'error':
      case 'loading':
        return this._state;
      default:
        return assertNever(this._state);
    }
  }

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'loading':
      case 'waiting':
        return nothing();
    }
  }
}

export default InvitationsOptionsStore;
